import BigNumber from 'bignumber.js'
import { ZERO } from 'constants/number'
import { Token2BNumber } from 'interfaces/index.interface'
import { makeAutoObservable } from 'mobx'

class OracleStore {
  /**
   * Price from oracle [poolAddr][underlying]
   */
  private poolPrices: Record<string, Record<string, BigNumber>>

  constructor() {
    this.poolPrices = {}
    makeAutoObservable(this)
  }

  getPrices = (poolAddr: string, assetAddr?: string): Token2BNumber => {
    return this.poolPrices[poolAddr]
  }

  getAssetPrice = (poolAddr: string, assetAddr?: string): BigNumber => {
    if (!assetAddr) return ZERO
    return this.poolPrices[poolAddr][assetAddr]
  }

  setPoolPriceOracle = (poolAddr: string, prices: Token2BNumber) => {
    this.poolPrices[poolAddr] = prices
  }
}

export const oracleStore = new OracleStore()
